// extracted by mini-css-extract-plugin
module.exports = {"container":"TeamSection_container__N6cOf"};